import { computed } from '#imports';
import type { NewsCardProps } from './types';

export const useNewsCardModel = (props: NewsCardProps) => {
  const image = computed(() =>
    props.layout !== 'default'
      ? props.post.pictures.IMG_SM || props.post.pictures.IMG_XS || ''
      : props.post.pictures.IMG_XS || props.post.pictures.IMG_SM || '',
  );
  const tag = computed(() => props.post.tags[0] ?? '');
  const cardClasses = computed(() =>
    `card news-card -small -article -m -stretch-x -${props.layout} g-col-md-4 g-col-lg-3`,
  );

  return { image, tag, cardClasses };
};
